import { render } from "./ReviewSitemapKeywordsModal.vue?vue&type=template&id=a75deb22&scoped=true"
import script from "./ReviewSitemapKeywordsModal.vue?vue&type=script&lang=js"
export * from "./ReviewSitemapKeywordsModal.vue?vue&type=script&lang=js"

import "./ReviewSitemapKeywordsModal.vue?vue&type=style&index=0&id=a75deb22&lang=scss&scoped=true"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a75deb22"]])

export default __exports__